// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-container[data-v-552bbad5]{position:relative;min-height:70px}.title-container .loader[data-v-552bbad5]{top:6px;height:7em;width:7em;left:5%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
